import managementService from "../../api/managementService";
import * as requestActions from "../requestActions";
import { setUIStep } from "../meActions";
import { intl } from "../../intl";
import { formatFileSize } from "../../components/Management/Cloud/util";
import { store } from "../../store";
import { resolveLanguage } from "../../utils/language";

const getRequestLanguage = () =>
  resolveLanguage(store.getState().user.userLanguage);

export const fetchUserList = (
  groupId = "",
  searchKeyword = "",
  limit = 10,
  offset = 0
) => {
  return async (dispatch) => {
    let response = await managementService.getUserList(
      groupId,
      searchKeyword,
      limit,
      offset
    );
    if (!response.data.error) {
      dispatch({
        type: "FETCH_USER_LIST",
        payload: response.data.payload,
      });
    }
  };
};

export const fetchUserListWithExcludedUSerIds = (
  groupId = "",
  searchKeyword = "",
  limit = 10,
  offset = 0,
  excludedUserIds
) => {
  return async (dispatch) => {
    let response = await managementService.getUserListWithExcludedUserIds(
      groupId,
      searchKeyword,
      limit,
      offset,
      { excludedUserIds }
    );
    if (!response.data.error) {
      dispatch({
        type: "FETCH_USER_LIST_WITH_EXCLUDED_USER_IDS",
        payload: response.data.payload,
      });
    }
  };
};

export const fetchUser = (userId) => {
  return async (dispatch) => {
    let response = await managementService.getUser(userId);
    if (!response.data.error) {
      dispatch({
        type: "FETCH_USER",
        payload: response.data.payload,
      });
    }
  };
};

export const clearUser = () => {
  return async (dispatch) => {
    dispatch({
      type: "CLEAR_USER",
    });
  };
};

export const getUserByParameter = (searchKey = "") => {
  return async (dispatch) => {
    let response = await managementService.getUserByParameter(searchKey);
    if (!response.data.error) {
      dispatch(fetchUserList());
    }
  };
};

export const sendVerificationEmail = (email) => {
  return async (dispatch) => {
    let response = await managementService.sendVerificationEmail(
      email,
      getRequestLanguage()
    );
    if (response.status === 200 && !response.data.error) {
      dispatch({
        type: "USER_EMAIL_VERIFICATION",
        payload: true,
      });
      dispatch(
        requestActions.notify({
          text: intl.formatMessage({
            id: "register.sendVerificationEmail",
            defaultMessage: "Verification Email Send.",
          }),
        })
      );
    } else if (
      response.status === 200 &&
      response.data.error &&
      response.data.payload === "USER_ALREADY_REGISTERED"
    ) {
      dispatch(
        requestActions.notify({
          type: "error",
          text: intl.formatMessage({
            id: "register.alreadyRegistered",
            defaultMessage: "User already registered.",
          }),
        })
      );
    } else if (
      response.status === 200 &&
      response.data.error &&
      response.data.payload === "EMAIL_ALREADY_SENT"
    ) {
      dispatch({
        type: "USER_EMAIL_VERIFICATION",
        payload: true,
      });
      dispatch(
        requestActions.notify({
          type: "error",
          text: intl.formatMessage({
            id: "register.EMAIL_ALREADY_SENT",
            defaultMessage: "Email already sent.",
          }),
        })
      );
    } else {
      dispatch(
        requestActions.notify({
          type: "error",
          text: intl.formatMessage({
            id: "register.operationFailed",
            defaultMessage: "Operation Failed.",
          }),
        })
      );
    }
  };
};

export const register = (user, verifyCode) => {
  return async (dispatch) => {
    let response = await managementService.register({ user, verifyCode });
    if (response.status === 200 && !response.data.error) {
      window.location = "/";
      dispatch(
        requestActions.notify({
          text: intl.formatMessage({
            id: "register.requestSent",
            defaultMessage: "Successful.",
          }),
        })
      );
      dispatch(setUIStep("AUTHENTICATED_ENTRANCE_SCREEN"));
    } else if (
      response.status === 200 &&
      response.data.error &&
      response.data.payload === "WrongVerificationCode"
    ) {
      dispatch(
        requestActions.notify({
          type: "error",
          text: intl.formatMessage({
            id: "register.wrongCode",
            defaultMessage: "Wrong Verification Code",
          }),
        })
      );
    } else {
      dispatch(
        requestActions.notify({
          type: "error",
          text: intl.formatMessage({
            id: "management.operationFailed",
            defaultMessage: "Operation failed!",
          }),
        })
      );
    }
  };
};

export const createUser = (user) => {
  return async (dispatch) => {
    let response = await managementService.createUser(user);
    if (!response.data.error) {
      dispatch(
        {
          type: "CREATE_USER",
          payload: response.data.payload,
        },
        requestActions.notify({
          text: intl.formatMessage({
            id: "user.userCreatedSuccessfully",
            defaultMessage: "User created successfully",
          }),
        })
      );
    } else if (response.data.payload === "GROUP_CLOUD_SPACE_NOT_ENOUGH") {
      dispatch(
        requestActions.notify({
          type: "error",
          text: intl.formatMessage({
            id: "user.userGroup.groupCloudSpaceNotEnough",
            defaultMessage: "Group cloud space is not enough!",
          }),
        })
      );
    } else if (response.data.payload === "USERNAME_ALREADY_TAKEN") {
      dispatch(
        requestActions.notify({
          type: "error",
          text: intl.formatMessage({
            id: "user.usernameAlreadyTaken",
            defaultMessage: "Username already taken!",
          }),
        })
      );
    } else if (
      response.data.error &&
      response.data.payload === "MAX_USER_LIMIT_HAS_FULLED"
    ) {
      dispatch(
        requestActions.notify({
          type: "error",
          text: intl.formatMessage({
            id: "user.userGroup.groupLimitHasFulled",
            defaultMessage: "Group Limit Has Fulled!",
          }),
        })
      );
    } else {
      dispatch(
        requestActions.notify({
          text: intl.formatMessage({
            id: "management.operationFailed",
            defaultMessage: "Operation failed!",
          }),
        })
      );
    }
  };
};

export const editUser = (user) => {
  return async (dispatch) => {
    let response = await managementService.editUser(user);
    if (!response.data.error) {
      dispatch(
        {
          type: "EDIT_USER",
          payload: response.data.payload,
        },
        requestActions.notify({
          text: intl.formatMessage({
            id: "user.userUpdatedSuccessfully",
            defaultMessage: "User updated successfully",
          }),
        })
      );
    } else if (response.data.payload.message === "ALREADY_USED_CLOUD_SPACE") {
      dispatch(
        requestActions.notify({
          type: "error",
          text: intl.formatMessage(
            {
              id: "user.cloudSpaceAlreadyUsed",
              defaultMessage: `Already {count} space used`,
            },
            {
              count: formatFileSize(response.data.payload.usedCloudSpace),
            }
          ),
        })
      );
    } else if (response.data.payload === "GROUP_CLOUD_SPACE_NOT_ENOUGH") {
      dispatch(
        requestActions.notify({
          type: "error",
          text: intl.formatMessage({
            id: "user.userGroup.groupCloudSpaceNotEnough",
            defaultMessage: "Group cloud space is not enough!",
          }),
        })
      );
    } else if (response.data.payload === "MAX_USER_LIMIT_HAS_FULLED") {
      dispatch(
        requestActions.notify({
          type: "error",
          text: intl.formatMessage({
            id: "user.userGroup.groupLimitHasFulled",
            defaultMessage: "Group Limit Has Fulled!",
          }),
        })
      );
    } else {
      dispatch(
        requestActions.notify({
          type: "error",
          text: intl.formatMessage({
            id: "management.operationFailed",
            defaultMessage: "Operation failed!",
          }),
        })
      );
    }
  };
};

export const setProfile = (user) => {
  return async (dispatch) => {
    let response = await managementService.setProfile(user);
    if (!response.data.error) {
      dispatch(
        {
          type: "SET_PROFILE",
          payload: response.data.payload,
        },
        requestActions.notify({
          text: intl.formatMessage({
            id: "user.userUpdatedSuccessfully",
            defaultMessage: "User updated successfully",
          }),
        })
      );
    } else if (response.data.payload.message === "ALREADY_USED_CLOUD_SPACE") {
      dispatch(
        requestActions.notify({
          type: "error",
          text: intl.formatMessage(
            {
              id: "user.cloudSpaceAlreadyUsed",
              defaultMessage: `Already {count} space used`,
            },
            {
              count: formatFileSize(response.data.payload.usedCloudSpace),
            }
          ),
        })
      );
    } else if (response.data.payload === "GROUP_CLOUD_SPACE_NOT_ENOUGH") {
      dispatch(
        requestActions.notify({
          type: "error",
          text: intl.formatMessage({
            id: "user.userGroup.groupCloudSpaceNotEnough",
            defaultMessage: "Group cloud space is not enough!",
          }),
        })
      );
    } else {
      dispatch(
        requestActions.notify({
          type: "error",
          text: intl.formatMessage({
            id: "management.operationFailed",
            defaultMessage: "Operation failed!",
          }),
        })
      );
    }
  };
};

export const deleteUser = (ids) => {
  return async (dispatch) => {
    let response = await managementService.deleteAllUsers(ids);
    if (!response.data.error) {
      dispatch(
        {
          type: "DELETE_USER",
          payload: response.data.payload,
        },
        requestActions.notify({
          text: intl.formatMessage({
            id: "user.userDeletedSuccessfully",
            defaultMessage: "User deleted successfully",
          }),
        })
      );
    } else {
      dispatch(
        requestActions.notify({
          type: "error",
          text: intl.formatMessage({
            id: "management.operationFailed",
            defaultMessage: "Operation failed!",
          }),
        })
      );
    }
  };
};
export const fetchLastUserList = (limit = 8, offset = 0) => {
  return async (dispatch) => {
    let response = await managementService.getLastUserList(limit, offset);
    if (!response.data.error) {
      dispatch({
        type: "FETCH_LAST_USER_LIST",
        payload: response.data.payload,
      });
    }
  };
};

export const sendPasswordEmail = (email) => {
  let body = { email: email };
  return async (dispatch) => {
    let response = await managementService.sendPasswordEmail(body, getRequestLanguage());
    if (response.status === 200 && !response.data.error) {
      dispatch(
        requestActions.notify({
          text: intl.formatMessage({
            id: "management.sendPasswordEmail",
            defaultMessage: "Password Email Send.",
          }),
        })
      );
    } else if (
      response.status === 200 &&
      response.data.error &&
      response.data.payload === "USER_NOT_FOUND"
    ) {
      dispatch(
        requestActions.notify({
          type: "error",
          text: intl.formatMessage({
            id: "user.userNotFound",
            defaultMessage: "User not found",
          }),
        })
      );
    } else {
      dispatch(
        requestActions.notify({
          type: "error",
          text: intl.formatMessage({
            id: "management.operationFailed",
            defaultMessage: "Operation Failed.",
          }),
        })
      );
    }
  };
};
